import React from "react";

const AppealStatus = ({status}) => {
    let data = status ? status.toString().toLowerCase() : "";
    switch (data) {
        case "declined":
            return (
                <>
                    <div className="assessment-03">
                        <span className="as-red-bg  as-widget">Declined</span>
                    </div>
                </>
            );
        case "approved":
            return (
                <>
                    <div className="assessment-03">
                        <span className="as-green-bg as-widget">Approved</span>
                    </div>
                </>
            );
        case "appeal-pending":
            return (
                <>
                    <div className="assessment-03">
                        <span className="as-yellow-bg as-widget">Appeal-Pending</span>
                    </div>
                </>
            );
        default:
            return (
                <>
                    <div className="assessment-03">
                        <span className="as-black-bg">-</span>
                    </div>
                </>
            );
            break;
    }
}
export default AppealStatus;
